// src/components/LoginForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginForm = ({ switchToRegister, onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate(); // Hook to navigate programmatically

    const handleSubmit = (e) => {
        e.preventDefault();
        // Implement your login logic here

        // Mock successful login
        const userData = { name: 'John Doe', email };
        onLogin(userData);

        // Redirect to "My Account" page
        navigate('/account');
    };

    return (
        <form onSubmit={handleSubmit} className="px-6 pb-6">
            <h2 className="text-2xl font-bold mb-4 text-center">Login</h2>
            <div className="mb-4">
                <label htmlFor="login-email" className="block text-gray-700">
                    Email
                </label>
                <input
                    id="login-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 border rounded-md"
                    required
                />
            </div>
            <div className="mb-6">
                <label htmlFor="login-password" className="block text-gray-700">
                    Password
                </label>
                <input
                    id="login-password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-3 py-2 border rounded-md"
                    required
                />
            </div>
            <button
                type="submit"
                className="w-full py-2 bg-secondary text-white rounded-md hover:bg-red-600 transition duration-300"
            >
                Login
            </button>
            <p className="mt-4 text-center text-gray-600">
                Don't have an account?{' '}
                <button
                    type="button"
                    onClick={switchToRegister}
                    className="text-primary hover:underline focus:outline-none"
                >
                    Register here
                </button>
            </p>
        </form>
    );
};

export default LoginForm;
